import { render } from "./OrderModal.vue?vue&type=template&id=8d3930a8"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=8d3930a8&lang=css"
script.render = render

export default script